module.exports = __webpack_public_path__ + "img/7076137.b2a26195.webp";